<script setup>
import { computed } from "vue";
import BaseButtonExchange from "@/components/ui/BaseButtonExchange.vue";
import { useSettingsStore } from "@/stores/storeSettings";

const storeSettings = useSettingsStore();
const props = defineProps({
	prize: {
		type: Object,
		required: true,
	},
	isShowExchange: {
		type: Boolean,
		default: false,
	},
	titleBtn: {
		type: String,
		default: "Обменять",
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	hideExchangeBtn: {
		type: Boolean,
		default: false,
	},
});

const isShowInfo = computed(() => (
	props.prize?.type === "point"
	&& !props.prize?.is_available
	&& props.prize?.format !== "certificate"
));

const emit = defineEmits(["exchange", "info"]);
</script>
<template>
	<div class="slide">
		<div :class="['slide__container', {'disabled': isShowInfo}]" @click="emit('info', prize)">
			<div class="info" v-if="isShowInfo">
				<p>Подарок пользовался большим спросом, поэтому быстро закончился</p>
			</div>
			<div class="slide__image" >
				<img width="236" height="236" :src="prize.images[0]" :alt="prize.title" />
			</div>
			<button class="slide__info" type="button" >
				<svg width="32" height="32"><use xlink:href="#info"></use></svg>
			</button>
		</div>
		<div class="slide__text" v-if="isShowExchange">
			<p class="slide__title">{{ prize.title }}</p>
			<div class="slide__price">
				<span class="slide__price-value">{{ prize.points }}</span>
				<span class="slide__price-icon">
					<svg width="32" height="32" class="leaf">
						<use xlink:href="#leaf"></use>
					</svg>
				</span>
			</div>
		</div>
		<BaseButtonExchange :disabled="disabled" v-if="props.isShowExchange && !props.hideExchangeBtn" class="slide__btn --small send-button --mobile-small" @click="emit('exchange', prize)">{{ props.titleBtn }}</BaseButtonExchange>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.slide {
	display: flex;
	flex-direction: column;
	gap: 0rem;
	align-items: flex-start;
	width: 100%;
	height: 100%;
	&__container {
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		width: 100%;
		border-radius: 4rem;
		border: 1px solid var(--border-accent-2-4);
		background: rgba(255, 255, 255, 0.01);
		backdrop-filter: blur(0.77rem);
		box-shadow: inset 0 1.3rem 3.48rem 0 rgba(255, 255, 255, 0.14);
		aspect-ratio: 1/1;
		margin-bottom: 1.5rem;
		@media (max-width: vars.$x480) {
			border-radius: 2.4rem;
			margin-bottom: 0.8rem;
		}
		@media (hover: hover) {
			&:hover {
				.slide__info {
					opacity: 0.7;
				}
			}
		}
		&.disabled {
			.slide__image {
				opacity: 0.2;
			}
		}
	}

	&__image {
		width: 23.6rem;
		height: 23.6rem;
		overflow: hidden;
		cursor: pointer;
		@media (max-width: vars.$x480) {
			width: 14.6rem;
			height: 14.6rem;
		}

		img {
			width: 100%;
			height: 100%;
			object-fit: contain;
		}
	}

	&__info {
		position: absolute;
		top: 1.5rem;
		right: 1.5rem;
		width: 3.2rem;
		height: 3.2rem;
		cursor: pointer;
		background: transparent;
		border: none;
		padding: 0;
		transition: opacity var(--transition);

		// @media (hover: hover) {
		// 	&:hover {
		// 		opacity: 0.7;
		// 	}
		// }

		@media (max-width: vars.$x480) {
			top: 1rem;
			right: 1rem;
			width: 2rem;
			height: 2rem;
		}

		svg {
			width: 100%;
			height: 100%;
			stroke: transparent;
		}
	}

	&__text {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		gap: 0rem;
		padding: 0 1.2rem 0.5rem;
		width: 100%;
		height: 100%;
		@media (max-width: vars.$x480) {
			gap: 0rem;
			padding: 0 0.8rem;
		}
	}

	&__title {
		font-family: var(--font-family);
		font-weight: 500;
		font-size: 2rem;
		line-height: 1.2;
		color: var(--text-inverse-100);
		max-width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		@media (max-width: vars.$x480) {
			font-size: 1.4rem;
		}
	}

	&__price {
		display: flex;
		align-items: center;
		gap: 0.8rem;
	}

	&__price-value {
		font-family: var(--second-family);
		font-weight: 700;
		font-size: 4.8rem;
		line-height: 140%;
		color: var(--text-accent-2-100);

		@media (max-width: vars.$x480) {
			font-size: 2.8rem;
		}
	}

	&__price-icon {
		width: 3.2rem;
		height: 3.2rem;
		display: flex;
		align-items: center;
		justify-content: center;

		@media (max-width: vars.$x480) {
			width: 2.6rem;
			height: 2.6rem;
		}
	}

	&__btn {
		width: 100%;
		margin-top: auto;
	}
}
.info {
	position: absolute;
	font-weight: 500;
	font-size: 1.4rem;
	line-height: 140%;
	letter-spacing: 0%;
	text-align: center;
	color: var(--Text-Accent-1-100, rgba(13, 46, 26, 1));

	background: var(--Fill-Accent-2-1, rgba(255, 208, 142, 1));
	width: 95%;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	border-radius: 1.6rem;
	padding-top: 16px;
	padding-right: 8px;
	padding-bottom: 16px;
	padding-left: 8px;
	z-index: 1;
}
</style>
